import React from 'react';
import CrudManager from '@/components/admin/CrudManager';

const AdminEvidence = () => (
  <CrudManager
    title="Clinical Evidence"
    subtitle="Per-ingredient traditional-use + modern-research summaries. Educational only."
    endpoint="/admin/evidence"
    idField="slug"
    useKeyInPath
    columns={[
      { key: 'ingredient_name', label: 'Ingredient' },
      { key: 'latin_name', label: 'Latin' },
      { key: 'evidence_strength', label: 'Strength' },
      { key: 'published', label: 'Published', render: (e) => e.published ? '✓' : '—' },
    ]}
    initial={{ slug: '', ingredient_name: '', latin_name: '', traditional_use: '', modern_research: '', evidence_strength: 'emerging', typical_study_duration: '', findings: '', safety: '', references: [], simple_summary: '', cover_image: '', published: true }}
    fields={[
      { key: 'slug', label: 'Slug', required: true },
      { key: 'ingredient_name', label: 'Ingredient name', required: true },
      { key: 'latin_name', label: 'Latin name' },
      { key: 'evidence_strength', label: 'Evidence strength', type: 'select', options: [
        { value: 'preliminary', label: 'Preliminary' },
        { value: 'emerging', label: 'Emerging' },
        { value: 'moderate', label: 'Moderate' },
        { value: 'strong', label: 'Strong' },
      ] },
      { key: 'traditional_use', label: 'Traditional Ayurvedic use', type: 'textarea', rows: 3 },
      { key: 'modern_research', label: 'Modern research summary', type: 'textarea', rows: 3 },
      { key: 'findings', label: 'Findings (educational)', type: 'textarea', rows: 3 },
      { key: 'typical_study_duration', label: 'Typical study duration' },
      { key: 'safety', label: 'Safety information', type: 'textarea', rows: 2 },
      { key: 'simple_summary', label: 'Simple summary (plain English)', type: 'textarea', rows: 2 },
      { key: 'references', label: 'References (JSON array of {title, url})', type: 'json', rows: 4, help: '[{"title":"...","url":"https://..."}]' },
      { key: 'cover_image', label: 'Cover image URL' },
      { key: 'published', label: 'Published', type: 'checkbox' },
    ]}
  />
);
export default AdminEvidence;
